import { useQuery } from '@tanstack/react-query';
import { RankGroupsQueryKeys } from '../../queryKeys';
import { fetchRankGrouById } from './service';
import { RankGroup } from '@/models/rank/group';
import { AxiosError } from 'axios';
import { GenericError } from '@/models/generic-error';
import { RankGroupByIdRequestDto } from '@/services/dto/rank-groups/rank-group-by-id-request.dto';

export function useRankGroupById(options: Partial<RankGroupByIdRequestDto>) {
  const { id } = options ?? {};
  const queryKey: [RankGroupsQueryKeys.ById, RankGroupByIdRequestDto] = [
    RankGroupsQueryKeys.ById,
    {
      id: id as bigint,
    },
  ];

  const { data, isPending, error, refetch, fetchStatus } = useQuery<
    RankGroup,
    AxiosError<GenericError>,
    RankGroup,
    [RankGroupsQueryKeys.ById, RankGroupByIdRequestDto]
  >({
    queryKey,
    queryFn: fetchRankGrouById,
    enabled: !!id,
  });

  return {
    rankGroup: data,
    isLoading: isPending && fetchStatus !== 'idle',
    error,
    refetch,
  };
}
